import request from "@/utils/request"

/**
 * 安全监测 —— 监测数据统计
 * 统计当前搜索条件下的监测正常 / 预警 / 报警次数（不包含分页参数）
 * 说明：url 为示例假路径，后端接口就绪后替换即可
 * 入参：{ dev_name, dev_type, asset_code, site_name }
 * 返回：{ normal_num, warn_num, alarm_num }
 */
export function getSafetyMonitorStatisticApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/SafetyMonitor/Statistic",
    method: "post",
    data
  })
}

/**
 * 安全监测 —— 异常数据分页列表
 * 说明：url 为示例假路径，后端接口就绪后替换即可
 * 入参：{ dev_name, dev_type, asset_code, site_name, page, pagesize }
 * 返回：{ data: [], total }
 * 列表字段：
 *   dev_name      设备名称
 *   dev_type      设备类型（power_transformer / power_cabinet / power_branch_box / power_charge_pile）
 *   asset_code    资产码
 *   site_name     所属站点名称
 *   alarm_type    异常类型（1 预警 / 2 报警）
 *   alarm_code    异常编码
 *   alarm_detail  异常详情
 *   alarm_num     异常数
 *   channel       通道（无通道时为空）
 *   address       详细地址
 *   alarm_time    异常时间
 */
export function getSafetyMonitorAbnormalPageListApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/SafetyMonitor/AbnormalPageList",
    method: "post",
    data
  })
}
